export default __webpack_public_path__ + "static/PL-f306837def796bf83ef810039b404c6a.jpg";